// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__38nwA","colMaxWidth":"Table_colMaxWidth__1Vg1N"};